<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      <div class="enterprise-network_container_title__left">
        Other Contacts
      </div>
      <div
        class="enterprise-network_container_title__right"
        title="Other contacts are usually pre-sales engineers, post-sales engineers, business personnel, etc."
      >
        Other contacts are usually pre-sales engineers, post-sales engineers, business personnel, etc.
      </div>
    </div>

    <div class="enterprise-network_container_table">
      <el-table :data="formData" border>
        <el-table-column
          label="Name"
          show-overflow-tooltip
          prop="generalManagerName"
        />
        <el-table-column
          label="Job Title"
          prop="position"
          show-overflow-tooltip
        />
        <el-table-column
          label="Work Email"
          prop="email"
          show-overflow-tooltip
        />
        <el-table-column
          label="Office Phone"
          prop="officePhone"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span v-if="row.officePhone">
              {{ row.officePhone }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="Operation">
          <template #default="{row, $index}">
            <div class="operation">
              <!--这里需要将svg变色，另外封组件并没有必要-->
              <div @click="handleEditContacts(row, $index)">
                <svg
                  id="edit_icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 679.9 680.1"
                >
                  <path
                    class="cls-1"
                    d="m81.6,680c-45,0-81.6-36.6-81.6-81.6V81.6C0,36.6,36.6,0,81.6,0h215.4c23.4,0,38.5,15.1,38.5,38.5s-15.2,38.5-38.6,38.5H124.6c-28.5,0-47.6,19.1-47.6,47.6v430.7c0,28.5,19.1,47.6,47.6,47.6h430.7c28.5,0,47.6-19.1,47.6-47.6v-172.2c0-23.4,15.1-38.5,38.5-38.5s38.5,15.1,38.5,38.5v215.4c0,45-36.6,81.6-81.6,81.6H81.6v-.1Zm236.9-280c-9.9,0-19.5-4.1-26.9-11.6-7.5-7.5-11.6-17-11.6-26.9s4.1-19.5,11.6-26.9L597.4,28.8c7.5-7.5,17-11.6,26.9-11.6s19.5,4.1,26.9,11.6c7.5,7.5,11.6,17,11.6,26.9s-4.1,19.5-11.6,26.9l-305.8,305.9c-7.5,7.4-17,11.5-26.9,11.5h0Z"
                  />
                </svg>
              </div>
              <el-popconfirm
                icon=""
                @confirm="handleDeleteContacts($index)"
                placement="top"
                cancel-button-text="Cancel"
                confirm-button-text="Delete"
                trigger="click"
              >
                <el-button slot="reference" type="text">
                  <div>
                    <svg
                      class="delete_icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 679 680"
                    >
                      <path
                        class="cls-1"
                        d="m406.71,536.46c-21.46,0-38.92-17.46-38.92-38.92v-243.29c0-21.46,17.46-38.92,38.92-38.92s38.92,17.46,38.92,38.92v243.16c0,21.53-17.46,39.05-38.92,39.05h0Z"
                      />
                      <path
                        class="cls-1"
                        d="m272.16,536.46c-21.46,0-38.92-17.46-38.92-38.92v-243.29c0-21.46,17.46-38.92,38.92-38.92s38.92,17.46,38.92,38.92v243.16c0,21.53-17.46,39.05-38.92,39.05h0Z"
                      />
                      <path
                        class="cls-1"
                        d="m38.92,197.47c-21.46,0-38.92-17.46-38.92-38.92s17.46-38.92,38.92-38.92h104.62v-32.85c0-47.85,38.93-86.78,86.78-86.78h218.88c47.56,0,86.26,38.93,86.26,86.77v32.85h104.62c21.46,0,38.92,17.46,38.92,38.92s-17.46,38.92-38.92,38.92H38.92Zm418.68-77.85v-32.85c0-5.17-3.54-8.92-8.41-8.92h-218.88c-4.84,0-8.92,4.09-8.92,8.92v32.85h236.22-.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m182.6,680c-47.85,0-86.77-38.93-86.77-86.77V253.98c0-21.46,17.46-38.92,38.92-38.92s38.92,17.46,38.92,38.92v339.25c0,4.92,4,8.92,8.92,8.92h314.06c4.92,0,8.92-4,8.92-8.92V254.88c0-21.46,17.46-38.92,38.92-38.92s38.92,17.46,38.92,38.92v338.34c-.16,47.85-39.14,86.77-86.9,86.77H182.6Z"
                      />
                    </svg>
                  </div>
                </el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-button class="add-button" @click="handleAddContacts">
        + Add
      </el-button>
    </div>
    <enterprise-network-add-contacts-model
      ref="addContactsModel"
      :visible.sync="isShowAddOrEditDialog"
      :isEditContract="isEditContract"
      @submit="handleAddContractsSubmit"
    />
  </div>
</template>

<script>
import EnterpriseNetworkAddContactsModel from "../addContactsDialog.vue";

export default {
  name: "enterpriseNetworkOtherContactsEdit",
  components: { EnterpriseNetworkAddContactsModel },
  data() {
    return {
      formData: [],
      isEditContract: false,
      editIndex: void 0,
      isShowAddOrEditDialog: false
    };
  },
  methods: {
    // 设置formData
    setFormData(formData) {
      this.formData = JSON.parse(JSON.stringify(formData));
    },
    // 获取formData
    getFormData() {
      if (this.isDetail) return;
      return JSON.parse(JSON.stringify(this.formData));
    },
    handleEditContacts(info, index) {
      this.$refs.addContactsModel.setFormData(info);
      this.isEditContract = true;
      this.editIndex = index;
      this.isShowAddOrEditDialog = true;
    },
    handleDeleteContacts(index) {
      this.formData = this.formData.filter(
        (_, itemIndex) => itemIndex !== index
      );
    },
    handleAddContacts() {
      this.isEditContract = false;
      this.isShowAddOrEditDialog = true;
    },
    handleAddContractsSubmit(info) {
      if (this.isEditContract) {
        this.formData.splice(this.editIndex, 1, info);
        this.isEditContract = false;
        this.editIndex = void 0;
      } else {
        this.formData.push(info);
      }
    }
  }
};
</script>

<style>
.add-button {
  margin-top: 10px;
  width: 100%;
}

.operation {
  display: flex;
  align-items: center;
  gap: 30px;
}

.operation div {
  height: 18px;
  line-height: 18px;
}

.operation svg {
  width: 18px;
  height: 18px;
  fill: #383838;
  stroke-width: 0;
  cursor: pointer;
}

.operation svg:hover {
  fill: #e60039;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/otherContacts/otherContactsEdit.vue